import React from 'react';
import PropTypes from 'prop-types';

import style from './Tab.module.scss';

const Tab = ({ children, ...rest }) => (
  <div {...rest} className={style.tab}>
    {children}
  </div>
);

export default Tab;

Tab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
